/**
 * useTx — ข้อความ 2 ภาษาแบบเขียนคู่กันในหน้า (22 ต.ค. 69 · ระบบ TH/EN)
 *
 *   const tx = useTx();
 *   tx("ตะกร้าเบิก", "Request cart")           → ตามภาษาที่เลือก (ปุ่ม EN/ไทย บนหัวเว็บ)
 *   tx({ th: "รอบผลิต", en: "Production run" }) → ใช้กับค่าคงที่ระดับไฟล์ (สถานะ ป้าย ฯลฯ)
 *
 * ทำไมไม่ใช้ t("key") อย่างเดียว: หน้าจอมีข้อความไทยหลายหมื่นจุด เขียนคู่กันในบรรทัดเดียว
 *   คนแก้เห็นทั้งสองภาษาทันที ไม่ต้องไปตามหาคีย์ในไฟล์ JSON · t() ยังใช้กับคำกลางที่ซ้ำทุกหน้า (locales/*.json)
 * ⚠ ภาษาไทยเป็นหลัก — ไม่มีคำอังกฤษ (undefined) = แสดงไทย
 */
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const pickLang = (lang, th, en) => {
  if (th && typeof th === "object" && !Array.isArray(th)) return lang === "en" && th.en != null ? th.en : th.th;
  return lang === "en" && en != null ? en : th;
};

export function useLang() {
  const { i18n } = useTranslation();
  return i18n.language?.startsWith("en") ? "en" : "th";
}

export function useTx() {
  const lang = useLang();
  // ตัวเดิมจนกว่าจะเปลี่ยนภาษา — ใส่ใน deps ของ useEffect/useMemo ได้ (28 ต.ค. 69)
  return useCallback((th, en) => pickLang(lang, th, en), [lang]);
}

// ตัวเลข/วันที่ตามภาษา — th-TH ใช้ พ.ศ. · en-GB ใช้ ค.ศ. แบบวัน/เดือน/ปี
export const localeOf = (lang) => (lang === "en" ? "en-GB" : "th-TH");
